import { Vue } from "vue-property-decorator"
import { commonObjectState } from "~/state/object"
import { IObjectState } from "~/state/types"
import { NewRequester } from "~/core/Requester"
import ObjectHelper from "~/utils/ObjectHelper"

interface IDataPluginState {
  dataPluginDetail: IObjectState<any>
}

export const prefix = "data-plugin/data-plugin"

export const state = (): IDataPluginState => ({
  dataPluginDetail: commonObjectState(),
})
export const getters = {
  getDetail: (state: any) => (): any => {
    return { ...(state.dataPluginDetail.data || {}) }
  },
}

export const mutations = {
  updateDetail: (state: IDataPluginState, data) => {
    Vue.set(state, "dataPluginDetail", data)
  },
}

export const actions = {
  getDetail: async ({ commit, state }, data) => {
    const path = `updateDetail`
    try {
      commit(path, ObjectHelper.toLoadingStatus(state.dataPluginDetail))
      const response = await NewRequester.get<any>(data.url, { ...data })
      commit(
        path,
        ObjectHelper.toObjSuccessStatus(state.dataPluginDetail, response.data)
      )
    } catch (e: any) {
      commit(
        path,
        ObjectHelper.toErrorStatus(
          state.dataPluginDetail,
          e.response?.data || e
        )
      )
    }
  },
}
